import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=38b23d6a&scoped=true&"
import script from "./RegisterPassword.vue?vue&type=script&lang=ts&"
export * from "./RegisterPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b23d6a",
  null
  
)

export default component.exports